
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M137.8 86.1c-34.1 2.2-54.8 9.7-70.5 25.5-9.3 9.4-16.1 22.8-19.8 38.8-7.4 32.8-2.5 48.6 24.3 78.9C83.1 242.2 85 245.9 85 256s-1.9 13.8-13.2 26.7c-16.4 18.5-23.4 30.4-26.4 44.3-1.9 9.2-1.3 19.2 2.1 34.6 6.7 29.4 23.3 48.4 50 57.3 22.2 7.4 36.3 8.1 158.5 8.1 123.2 0 136.6-.7 159.2-8.4 12.9-4.4 19.7-8.5 28.9-17.7 6.5-6.4 8.5-9.2 12.7-18 5.5-11.4 8.6-22.4 10.4-36.6 2.6-21.5-4.4-38.1-27-63.7-11.3-12.8-13.2-16.5-13.2-26.6s1.9-13.8 13.2-26.6c22.6-25.6 29.6-42.2 27-63.7-1.8-14.2-4.9-25.2-10.4-36.6-4.2-8.8-6.2-11.6-12.7-18-9.2-9.2-16-13.3-28.9-17.7-12.4-4.2-23.6-6.1-43.7-7.4-18.8-1.2-214.8-1.1-233.7.1M340 150.7c0 21-.3 24.3-1.9 27.8-7.6 16.4-29.8 16.6-38.2.3-1.7-3.4-1.9-6.1-1.9-27.8v-24h42zm-11.1 64.2c4.8 2.5 8.7 7.1 10.1 11.9.7 2.4 1 13.1.8 30.4l-.3 26.6-3 4.4c-9.7 13.8-30.6 11.8-37-3.4-1.2-3.1-1.5-8.5-1.5-29.8s.3-26.7 1.5-29.8c4.8-11.4 18.1-16 29.4-10.3m-2.1 105.7c2 .8 5 2.7 6.5 4.2 6 5.7 6.2 6.5 6.7 34l.5 25.2h-43l.5-25.2c.5-27.5.7-28.4 6.7-34 5.9-5.6 14.8-7.3 22.1-4.2"}})])
          )
        }
      }
    